"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _inOutBound = require("@/api/inOutBound");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  // 给props的title_prfix加上默认值
  props: ['selectedItem'],
  data: function data() {
    return {
      dialogVisible: false,
      formData: {
        id: '',
        amount: '',
        amount_remark: '',
        chassis_number: '',
        remark: '',
        cert_name: ''
      },
      defaultForm: {
        id: '',
        amount: '',
        amount_remark: '',
        chassis_number: '',
        remark: '',
        cert_name: ''
      },
      rules: {
        amount: [{
          required: true,
          message: '请输入金额',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    // 写一个计算属性，根据props传来的title值，得到新增转账记录还是编辑
    dialogTitle: function dialogTitle() {
      return this.selectedItem ? '编辑出库订单其他信息' : '添加出库订单其他信息';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      console.log('收到selectedItem', this.selectedItem);
      if (val) {
        this.formData = Object.assign(this.formData, this.selectedItem);
      } else {
        this.$refs['formData'].resetFields();
        this.formData = Object.assign(this.formData, this.defaultForm);
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;
      // this.$confirm("您确定要申请扣款吗？", "申请扣款", {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消'
      // }).then(() => {
      this.$refs['formData'].validate(function (valid) {
        if (valid) {
          var param = (0, _objectSpread2.default)({}, _this.formData);
          (0, _inOutBound.makeVehicleInfo)(param).then(function (res) {
            _this.$emit('getList');
            _this.close();
          }).catch(function () {});
        }
      });
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};
exports.default = _default;